import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadComponent } from './lead.component';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgZorroAntdModule } from 'src/app/ng-zorro-antd/ng-zorro-antd.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExportacaoLeadComponent } from './exportacao-lead/exportacao-lead.component';
import { ListaExportacaoLeadComponent } from './lista-exportacao-lead/lista-exportacao-lead.component';



@NgModule({
  declarations: [LeadComponent, ExportacaoLeadComponent, ListaExportacaoLeadComponent],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
  ]
})
export class LeadModule { }
